/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TunneledMcpConnection = {
  /**
   * Number of MCP consumer sessions currently pinned to this tunnel connection
   */
  activeConsumerSessions: number;
  /**
   * Number of active request substreams on this tunnel session
   */
  activeSubstreams: number;
  /**
   * Tunnel agent version reported by the connection
   */
  agentVersion?: string | undefined;
  /**
   * When this tunnel session connected
   */
  connectedAt: Date;
  /**
   * Gateway session ID for a live tunnel connection
   */
  gatewaySessionId: string;
  /**
   * Most recent heartbeat observed for this tunnel session
   */
  lastHeartbeatAt: Date;
  /**
   * User-provided tunnel metadata reported by the agent
   */
  metadata: { [k: string]: string };
  /**
   * Remote address reported by the gateway
   */
  remoteAddr?: string | undefined;
  /**
   * Customer-declared version of the MCP service behind this tunnel connection
   */
  serviceVersion: string;
};

/** @internal */
export const TunneledMcpConnection$inboundSchema: z.ZodMiniType<
  TunneledMcpConnection,
  unknown
> = z.pipe(
  z.object({
    active_consumer_sessions: z.int(),
    active_substreams: z.int(),
    agent_version: z.optional(z.string()),
    connected_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    gateway_session_id: z.string(),
    last_heartbeat_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    metadata: z.record(z.string(), z.string()),
    remote_addr: z.optional(z.string()),
    service_version: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "active_consumer_sessions": "activeConsumerSessions",
      "active_substreams": "activeSubstreams",
      "agent_version": "agentVersion",
      "connected_at": "connectedAt",
      "gateway_session_id": "gatewaySessionId",
      "last_heartbeat_at": "lastHeartbeatAt",
      "remote_addr": "remoteAddr",
      "service_version": "serviceVersion",
    });
  }),
);

export function tunneledMcpConnectionFromJSON(
  jsonString: string,
): SafeParseResult<TunneledMcpConnection, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TunneledMcpConnection$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TunneledMcpConnection' from JSON`,
  );
}
